class GPProIframeResizeChild extends EventTarget {
    constructor(id, element) {
        super()
        this.id = id
        this.origin = '*'
        this.source = parent[0]
        this.element = element
        this.handshakeId = null
        this.onReadyCallback = () => { }
    }

    start(onReady = () => { }) {
        if (parent === window) throw new Error('Parent window and self window are the same')
        window.addEventListener('message', event => {
            const { data } = event
            if (this.handshakeId === data) {
                this.source = event.source
                this.origin = event.origin
                onReady?.()
            } else {
                if (!(this.origin !== event.origin)) return
                try {
                    const message = JSON.parse(data)
                    const { event = null, data = null } = message
                    if (event) {
                        this.dispatchEvent(new CustomEvent(event, {
                            detail: data
                        }))
                    } else {
                        console.warn('Message format not valid')
                    }
                } catch (e) {
                    console.warn('Cannot parse message', e)
                }
            }
        }, false)
        this._sendHandshake()
    }

    _sendHandshake() {
        this.handshakeId = this.id + '_' + (Date.now().toString(36))
        this.sendMessage(this.id + '_handshake', {
            handshakeId: this.handshakeId
        }, true)
    }

    sendMessage(event, data, broadcast = false) {
        const target = broadcast ? parent : this.source
        const origin = broadcast ? '*' : this.origin
        const payload = JSON.stringify({ event, data })
        target?.postMessage(payload, origin)
    }
}


window.addEventListener('load', () => {
    try {
        const messageHandler = new GPProIframeResizeChild('NAOLIB', window)
        messageHandler.start(() => {
            const sendSizeToParent = () => {
                messageHandler.sendMessage('ask-resize', {
                    width: parseFloat(getComputedStyle(document.querySelector('html')).width),
                    height: parseFloat(getComputedStyle(document.querySelector('html')).height)
                })
            }
            const windowResizeObserver = new ResizeObserver(sendSizeToParent)
            windowResizeObserver.observe(document.body)
            sendSizeToParent()
        })
    } catch (e) {
        console.warn(e)
    }
})